import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-suspended-fill 329",
  "use": "icon-suspended-fill 329-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 1024 1024\" id=\"icon-suspended-fill 329\"><path d=\"M512 128c200.298667 0 362.666667 162.368 362.666667 362.666667s-162.368 362.666667-362.666667 362.666666S149.333333 690.965333 149.333333 490.666667 311.701333 128 512 128z m-42.666667 234.666667h-64v277.333333h64V362.666667z m138.666667 0h-64v277.333333h64V362.666667z\" p-id=\"22415\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol